import { useEffect, useState } from 'react';

/**
 * Tracks a CSS media query from React.
 *
 * For plain restyling, write the media query in the stylesheet. This is for the cases CSS
 * cannot express — moving a node to a different place in the tree — so those follow the
 * same breakpoints the stylesheet uses.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const list = window.matchMedia(query);
    setMatches(list.matches);

    const onChange = (event: MediaQueryListEvent) => setMatches(event.matches);
    list.addEventListener('change', onChange);
    return () => list.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}
